import { getLanguageCode } from "./languageHelper"
import { client } from "@sart/client"

export async function updateNotifications(userId) {
	var language = getLanguageCode(client.cache.language)
	// get the list of Customer Notifications from the SSB
	var notificationList = []
	var newNotifications = false
	var newNotificationsTotal = 0
	
	try {
		var notificationListFromAPI = await client.callApi('contentCms','getCustomerNotificationPages',[1,{userId:userId,lang:language,accessControlled:true}])
		// Loop through the list of Customer Notifications to get the PAC
		
		for (var i = 0; i < notificationListFromAPI.length; i++) {
			var notification = notificationListFromAPI[i]
			var notificationPAC = await client.callApi('contentCms','getPageAccessControls',[1,notification.pageId,{userId:userId}])
			if(notificationPAC[0].status === "new" && notification.dateExpires > new Date) {
				newNotifications = true
				newNotificationsTotal = newNotificationsTotal + 1
			}
			notification.pac = notificationPAC[0]
			//Only add notification to the list if it is in the 'new' or 'seen' status
			if((notificationPAC[0].status === "new" || notificationPAC[0].status === "seen") && notification.dateExpires > new Date()) {
				notificationList.push(notification)
			}
		}
	} catch(e) {
		throw new Error(e.message)
	}
	// Update Cache of Customer Notifications
	// Set number of new Notifications
	client.setCache({ 
		notifications: notificationList,
		newNotifications,
		newNotificationsTotal
	})
}

export function getNotificationType(notification) {
	return notification.tags.find( t => t.tag !== null).tag
}

export async function updateNotificationStatus(notification, newStatus) {
	var newPac = notification.pac
	newPac.status = newStatus
	// Then use the update API to update the PAC in the SSB
	try {
		var updatedPac = await client.callApi('contentCms','modifyPageAccessControls',[1,notification.pageId,newPac.linkId,newPac])
	} catch (error) {
		throw new Error(e.message)
	} finally {
		updateNotifications(newPac.userId)
	}
}